<template>
  <div class="group-detail">
    <h1 class="common__main-title">Upload csv</h1>
    <div class="common__sub-title">Upload csv file</div>
    <div class="content-wrapper">
      <div class="main-content">
        <div>
          <h3 class="common__search-title">csv file</h3>
          <FileInput v-model="selectedCsv" @onFileChange="onSelectedCsv" ref="csv" />
          <ErrorCsv :errorMessages="errorMessages" />
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{name:'Evaluations'}"
        >
          Back
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="confirmUploadCsv"
        >
          Import
        </b-button>
      </div>
    </div>
    <ConfirmModal ref="confirmModal" isLoadingMode @ok="registerEvaluations" />
    <SuccessModal ref="sucessModal" @ok="vm.$router.push({name:'Evaluations'})"/>
  </div>
</template>

<script>
import _ from 'lodash';
import FileInput from '@/components/parts/inputItem/FileInput.vue';
import ConfirmModal from '@/components/parts/modal/Confirm.vue';
import SuccessModal from '@/components/parts/modal/Success.vue';
import ErrorCsv from '@/components/parts/ErrorCsv.vue';

export default {
  created() {
    this.vm = this;
  },

  data() {
    return {
      selectedCsv: null,
      errorMessages: [],
      isReload: false,
      vm: null,
    }
  },

  components: {
    FileInput,
    ConfirmModal,
    SuccessModal,
    ErrorCsv,
  },
  methods: {
    confirmUploadCsv() {
      if (!this.selectedCsv) {
        this.errorMessages = ['required csv file.'];
        return;
      }
      if (this.isReload) return
      this.isReload = false;
      this.errorMessages = [];
      try {
        // 登録数チェック
        this.isReload = true;
        const reader = new FileReader();
        reader.readAsText(this.selectedCsv);
        reader.onload = () => {
          // ヘッダの一行は除いてインポート人数の確認モーダルを表示
          this.isReload = false;
          const recordsCount = _.chain(reader)
            .get('result')
            .split('\n')
            .drop()
            .compact()
            .value()
            .length;

          this.$refs.confirmModal.open(`Import ${recordsCount} evaluationss. Is it OK?`);
        };
        reader.onerror = () => {
          // 読み取り失敗の場合、画面リロード
          this.errorMessages = ['selected file has error. please select file again.'];
          this.$refs.csv.reset();
        }
      } catch (error) {
        this.setErrors(error);
        this.$refs.confirmModal.close();
      }
    },
    registerEvaluations() {
      // インポート処理
      const conditions = {};
      const page = 1;

      this.$store.dispatch('importEvaluationsByCsv', this.selectedCsv)
        .then(() => {
          this.$refs.confirmModal.close();
          this.$store.dispatch('fetchEvaluations', { conditions, page });
          this.$refs.sucessModal.open();
        })
        .catch((error) => {
          this.setErrors(error);
          this.$refs.confirmModal.close();
        });
    },
    onSelectedCsv(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.selectedCsv = _.head(files);
    },
    setErrors(error) {
      this.errorMessages = [error];
      if (error.response) {
        let errors = _.chain(error.response)
          .get('data.message').value();
        if (_.some(errors, (o) => _.has(o, 'message'))) {
          errors = errors
            .map(({ index, message }) => `row ${index} evaluation has error: ${message}`);
        }
        this.errorMessages = Array.isArray(errors) ? errors : [errors];
      }
    },
  },
};

</script>

<style scoped>
.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
  min-height: 500px;
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
}
</style>
